import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { LtrtEntities } from 'client/data/models/long-term-road-test';
import { UnorderedList } from 'site-modules/shared/components/unordered-list/unordered-list';

export function LtrtSummary({ ltrtContent: { dataPoints, bullets }, heroImage }) {
  return (
    <Row className="ltrt-summary">
      <Col xs={12} md={6} lg={5} className="hero-image-wrapper px-0 px-md-0_5 mb-0_5">
        <img className="w-100" alt={heroImage.imageTitle} src={heroImage.imageUrl} />
      </Col>
      <Col xs={12} md={6} lg={7}>
        {dataPoints && !!(dataPoints.miles || dataPoints.mpg) && (
          <Row className="mb-1_5">
            <Col xs={12} lg={9} xl={7}>
              <table className="w-100" cellPadding={0} cellSpacing={0}>
                <colgroup>
                  <col width="50%" />
                  <col width="50%" />
                </colgroup>
                <thead>
                  <tr>
                    {dataPoints.miles && <td className="label text-gray-dark">{dataPoints.milesDrivenTitle}</td>}
                    {dataPoints.mpg && <td className="label text-gray-dark">{dataPoints.avgMpgTitle}</td>}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {dataPoints.miles && <td className="heading-4 fw-normal">{dataPoints.miles}</td>}
                    {dataPoints.mpg && <td className="heading-4 fw-normal">{dataPoints.mpg}</td>}
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        )}

        <UnorderedList
          title={bullets.label}
          items={bullets.value}
          titleClasses="heading-5 mb-0_5"
          listClasses="text-gray-darker mb-1_5 mb-md-1 ps-1 size-10"
          textClasses="size-16 align-middle"
          listItemClasses="mb-0_5"
        />
      </Col>
      <hr className="w-100 mt-1_5 mb-2 mx-0_5" />
    </Row>
  );
}

LtrtSummary.propTypes = {
  ltrtContent: LtrtEntities.LtrtContent.isRequired,
  heroImage: PropTypes.shape({
    imageUrl: PropTypes.string,
    imageTitle: PropTypes.string,
  }),
};

LtrtSummary.defaultProps = {
  heroImage: null,
};
